export const SESSION_STORAGE = {
	PARTICIPANT_SESSION_ID: "PARTICIPANT_SESSION_ID",
	JOURNEY_LOCATION: "JOURNEY_LOCATION",
	BUSINESSID: "BUSINESSID",
	MERCHANT_ID: "MERCHANT_ID",
	ORDERID: "ORDERID",
	RESOURCE_ID: "RESOURCE_ID",
	LIVE_CATALOGUE_ID: "LIVE_CATALOGUE_ID",
	CURRENT_TAB: "CURRENT_TAB",
	BUSINESS_DETAILS_ID: "BUSINESS_DETAILS_ID",
	BUSINESS_DETAILS: "BUSINESS_DETAILS",
	CART_VALUE: "CART_VALUE",
	VOUCHER: "VOUCHER",
	SESSION_ID: "SESSION_ID",
	BUSINESS_STATUS: "BUSINESS_STATUS",
	RESERVATION_DETAILS: "RESERVATION_DETAILS",
	RESERVATION_ID: "RESERVATION_ID",
	TIP_AMOUNT: "TIP_AMOUNT",
	DEFAULT_Tip: "DEFAULT_Tip",
	RESERVATION_TIME: "RESERVATION_TIME",
	RELOAD: "RELOAD",
	VERTICAL: "VERTICAL",
	CURRENT_ORDER: "CURRENT_ORDER",
	BUSINESS_ID: "BUSINESS_ID",
	ORDER_ID: "ORDER_ID",
	CATALOGUE_ID: "CATALOGUE_ID",
	BUSINESS_NAME: "BUSINESS_NAME",
	BUSINESS_PHONE: "BUSINESS_PHONE",
	PREVIOUS_URL: "previousUrl",
	CURRENT_URL: "currentUrl",
};
